{
  "name": "ikp-frontends",
  "version": "kunde-v1.10.0-SNAPSHOT-5bbdbd05ff1c1f26c1d2b5538f4ab81dd463d555",
  "engines": {
    "npm": ">=10.0.0",
    "node": ">=20.19.0"
  },
  "projects": {
    "ikp": "apps/ikp",
    "ikp-berater": "apps/ikp-berater"
  },
  "scripts": {
    "ng": "nx",
    "reset": "nx reset",
    "start": "nx serve",
    "start:expose-host": "nx serve --host 0.0.0.0",
    "ikp": "pnpm nx run ikp:serve:local",
    "berater": "pnpm nx run ikp-berater:serve:local",
    "messages": "pnpm nx run messages-control:serve:devtest",
    "devInt": "pnpm nx run meinewe:serve:devint",
    "build": "pnpm nx build",
    "test": "pnpm nx run-many --target=test --all",
    "analyze": "ng build --prod --stats-json && webpack-bundle-analyzer dist/ikp/stats.json",
    "full-test": "pnpm run test && pnpm nx run-many --target=e2e --all",
    "prepare": "husky",
    "newrelic:local": "SET NODE_ENV=development && node ",
    "newrelic:local:linux": "export NODE_ENV=development && node ",
    "storybook": "nx storybook storybook",
    "parse-version": "node parse-version.js"
  },
  "private": true,
  "dependencies": {
    "@aarsteinmedia/dotlottie-player-light": "^6.0.0",
    "@angular-architects/ngrx-toolkit": "^20.5.0",
    "@angular/animations": "20.3.15",
    "@angular/cdk": "20.2.14",
    "@angular/common": "20.3.15",
    "@angular/compiler": "20.3.16",
    "@angular/core": "20.3.16",
    "@angular/forms": "20.3.15",
    "@angular/localize": "20.3.15",
    "@angular/platform-browser": "20.3.15",
    "@angular/platform-browser-dynamic": "20.3.15",
    "@angular/router": "20.3.15",
    "@azure/msal-angular": "^4.0.21",
    "@azure/msal-browser": "^4.26.1",
    "@editorjs/editorjs": "^2.31.0",
    "@editorjs/list": "^2.0.8",
    "@editorjs/paragraph": "^2.11.7",
    "@fortawesome/fontawesome-free": "6.7.2",
    "@fortawesome/fontawesome-pro": "6.7.2",
    "@fortawesome/fontawesome-svg-core": "6.7.2",
    "@fortawesome/free-solid-svg-icons": "6.7.2",
    "@ng-bootstrap/ng-bootstrap": "19.0.1",
    "@ngrx/operators": "^20.1.0",
    "@ngrx/signals": "20.1.0",
    "@ngx-translate/core": "17.0.0",
    "@ngx-translate/http-loader": "17.0.0",
    "@popperjs/core": "^2.11.8",
    "@tanstack/angular-table": "^8.21.3",
    "@wienenergiegithub/modules-next": "4.87.6",
    "@wienenergiegithub/we-t1-bootstrap-theme": "2.10.1",
    "angular-oauth2-oidc": "^20.0.2",
    "bootstrap": "^5.3.6",
    "buffer": "^6.0.3",
    "chart.js": "^4.5.1",
    "chartjs-plugin-annotation": "^3.1.0",
    "data-forge": "^1.10.4",
    "dayjs": "^1.11.19",
    "editorjs-drag-drop": "^1.1.16",
    "editorjs-header-with-anchor": "^2.6.0",
    "js-cookie": "^3.0.5",
    "keycloak-angular": "^20.1.0",
    "keycloak-js": "^26.2.2",
    "my-ua-parser": "^2.0.4",
    "ng2-charts": "^8.0.0",
    "ngx-webstorage": "20.0.0",
    "qrious": "^4.0.2",
    "rxjs": "7.8.2",
    "short-unique-id": "^5.3.2",
    "storybook": "10.1.10",
    "swiper": "^12.0.3",
    "tslib": "^2.8.1",
    "uuid": "^13.0.0",
    "zone.js": "0.15.1"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "20.3.12",
    "@angular-devkit/core": "20.3.12",
    "@angular-devkit/schematics": "20.3.12",
    "@angular-eslint/builder": "20.6.0",
    "@angular-eslint/eslint-plugin": "20.6.0",
    "@angular-eslint/eslint-plugin-template": "20.6.0",
    "@angular-eslint/schematics": "20.6.0",
    "@angular-eslint/template-parser": "20.6.0",
    "@angular-eslint/utils": "20.6.0",
    "@angular/cli": "~20.3.12",
    "@angular/compiler-cli": "20.3.15",
    "@angular/language-service": "20.3.15",
    "@chromatic-com/storybook": "^4.1.3",
    "@eslint/eslintrc": "^3.3.1",
    "@eslint/js": "~9.39.1",
    "@nx/angular": "22.1.3",
    "@nx/cypress": "22.1.3",
    "@nx/eslint": "22.1.3",
    "@nx/eslint-plugin": "22.1.3",
    "@nx/jest": "22.1.3",
    "@nx/js": "22.1.3",
    "@nx/plugin": "22.1.3",
    "@nx/storybook": "22.1.3",
    "@nx/web": "22.1.3",
    "@nx/workspace": "22.1.3",
    "@openapitools/openapi-generator-cli": "^2.28.0",
    "@schematics/angular": "20.3.12",
    "@storybook/addon-a11y": "10.1.10",
    "@storybook/addon-docs": "10.1.10",
    "@storybook/angular": "10.1.10",
    "@storybook/builder-webpack5": "10.1.10",
    "@storybook/test-runner": "0.24.1",
    "@swc-node/register": "1.11.1",
    "@swc/core": "1.15.1",
    "@swc/helpers": "^0.5.17",
    "@types/jest": "30.0.0",
    "@types/js-cookie": "^3.0.6",
    "@types/node": "24.10.0",
    "@typescript-eslint/eslint-plugin": "8.46.4",
    "@typescript-eslint/utils": "8.46.4",
    "angular-eslint": "20.6.0",
    "baseline-browser-mapping": "^2.8.4",
    "command-line-args": "^6.0.1",
    "cypress": "15.6.0",
    "default-composer": "^0.6.0",
    "dpdm": "^3.14.0",
    "esbuild": "^0.27.0",
    "esbuild-plugin-copy": "^2.1.1",
    "esbuild-plugin-json-merge": "^0.1.0",
    "eslint": "9.39.1",
    "eslint-config-prettier": "10.1.8",
    "eslint-plugin-cypress": "5.2.0",
    "eslint-plugin-import": "2.x",
    "eslint-plugin-json": "^4.0.1",
    "eslint-plugin-prettier": "^5.5.4",
    "eslint-plugin-sonarjs": "^3.0.5",
    "eslint-plugin-storybook": "10.1.10",
    "eslint-plugin-unused-imports": "^4.3.0",
    "globals": "^16.5.0",
    "husky": "^9.1.7",
    "jasmine-core": "5.12.1",
    "jasmine-spec-reporter": "7.0.0",
    "jest": "30.2.0",
    "jest-canvas-mock": "^2.5.2",
    "jest-environment-jsdom": "30.2.0",
    "jest-fail-on-console": "^3.3.1",
    "jest-jasmine2": "30.2.0",
    "jest-junit": "^16.0.0",
    "jest-preset-angular": "15.0.3",
    "jest-sonar-reporter": "^2.0.0",
    "jest-util": "30.2.0",
    "jsonc-eslint-parser": "^2.4.1",
    "lint-staged": "^16.2.6",
    "merge-jsons-webpack-plugin": "^2.0.1",
    "mockdate": "^3.0.5",
    "ng-mocks": "^14.14.0",
    "ng-packagr": "20.3.0",
    "nx": "22.1.3",
    "object-code": "^1.3.4",
    "prettier": "^3.5.3",
    "selenium-webdriver": "^4.38.0",
    "sonar-scanner": "^3.1.0",
    "storybook-addon-designs": "^6.3.1",
    "storybook-addon-mock": "^6.0.1",
    "ts-jest": "29.4.5",
    "ts-node": "10.9.2",
    "typescript": "5.9.3",
    "typescript-eslint": "8.46.4"
  },
  "pnpm": {
    "overrides": {
      "@modelcontextprotocol/sdk@<1.25.2": ">=1.25.2",
      "esbuild@<=0.24.2": ">=0.24.2",
      "qs@<6.14.1": ">=6.14.1",
      "systeminformation@<5.27.14": ">=5.27.14",
      "diff@<8.0.3": ">=8.0.3",
      "tar@<=7.5.2": ">=7.5.3",
      "lodash-es@>=4.0.0 <=4.17.22": ">=4.17.23",
      "lodash@>=4.0.0 <=4.17.22": ">=4.17.23",
      "hono@<4.11.7": ">=4.11.7",
      "tar@<7.5.7": ">=7.5.7"
    }
  },
  "jestSonar": {
    "reportPath": "target/test-results/jest",
    "reportFile": "TESTS-results-sonar.xml"
  }
}
